import SideMenu from '@/containers/side-menu/SideMenu.vue'
import OccupationRate from '@/pages/reports/occupation-rate/OccupationRate.vue';

export default {
  path: '/occupation-rate',
  name: 'OccupationRate',
  components: {
    mainContent: OccupationRate,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'report-occupation-rate'
    },
    breadcrumb: {
      title: 'Relatório Ocupação',
      paths: [
        { title: 'Relatórios' },
        { title: 'Ocupação' }
      ]
    }
  }
}